var _style, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.4 40",
    style: {
      enableBackground: "new 0 0 115.4 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF2C91;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97,25.2c-10.1,0-10.4-4.3-20-4.3c-8.3,0-8.5,4.3-18.5,4.3c-10.1,0-10.4-4.3-20-4.3c-8.3,0-8.5,4.3-18.5,4.3 c-10.1,0-10.4-4.3-20-4.3v16.5h38.4h38.5h38.5V20.9C107.2,20.9,107,25.2,97,25.2z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave1);
export default __webpack_public_path__ + "static/media/wave_1.362b09288c82698ec9d9d90a29cae6de.svg";
export { ForwardRef as ReactComponent };